export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f61ae483732754f6321526c18ff36795ac7d73c4f&name=fetchTypeahead!'